import React, { Fragment } from "react";
import { Form, Row, Col } from "react-bootstrap";
import useValidation from "../../util/useValidation";
import {
  alphaNumericWithSpecialCharacterPattern,
  yearPattern
} from "../../constants/constants";
export const ClassXForm = ({
  qualificationTypeID,
  classXDetails,
  handleOnChangeQualificationDetails
}) => {
  const currentClassXDetails = classXDetails[0] || {};
  const { handleOnBlurValidation, errors } = useValidation();
  const handOnBlurInput = e => {
    handleOnBlurValidation(e);
  };
  const handleOnChangeClassXDetails = e => {
    handleOnChangeQualificationDetails(
      e,
      qualificationTypeID,
      currentClassXDetails
    );
  };
  return (
    <Fragment>
      <h6>Class X Details</h6>
      <Form.Group as={Row} controlId="board">
        <Form.Label column sm={2}>
          Board/Authority*
        </Form.Label>
        <Col sm={10}>
          <Form.Control
            size="sm"
            required
            placeholder="Board / Authority"
            type="text"
            name="degree"
            value={currentClassXDetails.degree}
            onChange={handleOnChangeClassXDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.degree}
            pattern={alphaNumericWithSpecialCharacterPattern}
          />
          {errors.degree && (
            <Form.Control.Feedback type="invalid">
              {errors.degree.type === "required" &&
                "Board/Authority is required"}
              {errors.degree.type === "pattern" &&
                "Invalid characters entered for Board/Authority"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId="yearGrade">
        <Form.Label column sm={2}>
          Completed Year*
        </Form.Label>
        <Col sm={4}>
          <Form.Control
            size="sm"
            placeholder="Year of Completion"
            type="text"
            name="completionYear"
            value={currentClassXDetails.completionYear}
            onChange={handleOnChangeClassXDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.completionYear}
            pattern={yearPattern}
            required
          />
          {errors.completionYear && (
            <Form.Control.Feedback type="invalid">
              {errors.completionYear.type === "required" &&
                "Completed Year is required"}
              {errors.completionYear.type === "pattern" &&
                "Please enter valid Year"}
            </Form.Control.Feedback>
          )}
        </Col>
        <Form.Label column sm={2} className="text-right">
          Percentage/Grade*
        </Form.Label>
        <Col sm={4}>
          <Form.Control
            size="sm"
            placeholder="Percentage/Grade"
            type="text"
            name="grade"
            value={currentClassXDetails.grade}
            onChange={handleOnChangeClassXDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.grade}
            pattern={alphaNumericWithSpecialCharacterPattern}
            required
          />
          {errors.grade && (
            <Form.Control.Feedback type="invalid">
              {errors.grade.type === "required" &&
                "Percentage/Grade is required"}
              {errors.grade.type === "pattern" &&
                "Please enter a valid Percentage/Grade "}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="school">
        <Form.Label column sm={2}>
          School*
        </Form.Label>
        <Col sm={10}>
          <Form.Control
            size="sm"
            required
            placeholder="School"
            type="text"
            name="college"
            value={currentClassXDetails.college}
            onChange={handleOnChangeClassXDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.college}
            pattern={alphaNumericWithSpecialCharacterPattern}
          />
          {errors.college && (
            <Form.Control.Feedback type="invalid">
              {errors.college.type === "required" && "School is required"}
              {errors.college.type === "pattern" &&
                "Invalid characters entered for School"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="location">
        <Form.Label column sm={2}>
          Location*
        </Form.Label>
        <Col sm={10}>
          <Form.Control
            size="sm"
            required
            placeholder="Location"
            type="text"
            name="location"
            value={currentClassXDetails.location}
            onChange={handleOnChangeClassXDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.location}
            pattern={alphaNumericWithSpecialCharacterPattern}
          />
          {errors.location && (
            <Form.Control.Feedback type="invalid">
              {errors.location.type === "required" && "Location is required"}
              {errors.location.type === "pattern" &&
                "Invalid characters entered for Location"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>
    </Fragment>
  );
};
export default ClassXForm;
